import { render, staticRenderFns } from "./InteractionItem.vue?vue&type=template&id=7b2fd8f6&scoped=true&"
import script from "./InteractionItem.vue?vue&type=script&lang=js&"
export * from "./InteractionItem.vue?vue&type=script&lang=js&"
import style0 from "./InteractionItem.vue?vue&type=style&index=0&id=7b2fd8f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2fd8f6",
  null
  
)

export default component.exports